import type {CategoryTier} from '@/modules/FinancialHealthScore/scoring';

export const TRANSITION_MS = 400;
export const QUALIFIED_THRESHOLD = 250_000;

export const PRIVACY_EMAIL = 'privacy@zoefin.com';
export const PRIVACY_POLICY_URL = 'https://zoefin.com/privacy-policy/';
export const STANDARD_CONTINUE_URL = 'https://findanadvisor.com/articles';
export const LEAD_INGEST_URL = process.env.NEXT_PUBLIC_LEAD_INGEST_URL ?? '';
export const FORM_ADV_URL = 'https://zoefinancial.com/legal/form-adv-part-2a';

export const QUALIFIED_FIND_ADVISOR_URL =
  'https://my.zoefin.com/find-an-advisor';

export const FORM_CRS_URL =
  'https://zoefinancial.com/legal/crs-conversation-starters';

export const BADGE_LABEL: Record<CategoryTier, string> = {
  'looking-good': 'Looking good',
  'worth-a-look': 'Worth a look',
  'needs-attention': 'Needs attention',
};

export const HEADLINE_BY_TIER: Record<CategoryTier, string> = {
  'looking-good': 'Your Financial Health is Strong.',
  'worth-a-look': 'Your Financial Health is Moderate.',
  'needs-attention': 'Your Financial Health Needs Attention.',
};

// Geometry helpers for the score dial — 10 annular wedge segments arranged
// in a downward-opening semicircle. Each wedge uses quadratic fillets at all
// four corners so the rounding is explicit geometry rather than a stroke
// hack, which keeps the shape consistent across renderers (DOM SVG and
// @react-pdf/renderer's <Svg> primitive both consume the same path `d`).

export const TOTAL_SEGMENTS = 10;
export const SVG_WIDTH = 400;
export const SVG_HEIGHT = 230;

export const CENTER_X = SVG_WIDTH / 2;
export const CENTER_Y = 215;
export const OUTER_R = 180;
export const INNER_R = 105;
export const CORNER_R = 8;
export const SEGMENT_GAP_DEG = 4;
export const SEGMENT_SPAN = 180 / TOTAL_SEGMENTS;

// Fill color per score tier; unfilled wedges use UNFILLED_FILL.
export const TIER_FILL: Record<
  'looking-good' | 'worth-a-look' | 'needs-attention',
  string
> = {
  'looking-good': '#009966',
  'worth-a-look': '#efa92e',
  'needs-attention': '#d36564',
};

export const UNFILLED_FILL = '#e8edf9';
